import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-6670de18")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "p-d-flex p-jc-center p-ai-center p-fluid p-mb-3" }
const _hoisted_3 = { class: "card p-d-flex p-jc-between" }
const _hoisted_4 = { class: "p-field p-text-center" }
const _hoisted_5 = { class: "p-field p-ml-3 p-text-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "zone_autocomplete" }, [
  /*#__PURE__*/_createElementVNode("strong", null, " Città ")
], -1)
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "days" }
const _hoisted_9 = { class: "checkboxes" }
const _hoisted_10 = {
  key: 1,
  class: "pi pi-ban text-danger",
  style: {"width":"1.5rem"}
}
const _hoisted_11 = { class: "p-my-3 p-ml-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-ban text-danger",
  style: {"width":"20px"}
}, null, -1)
const _hoisted_13 = { class: "p-ml-3" }
const _hoisted_14 = { class: "p-ml-3" }
const _hoisted_15 = { class: "p-text-center p-text-light" }
const _hoisted_16 = {
  key: 0,
  class: "p-text-center p-text-light"
}
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_WeekNavigator = _resolveComponent("WeekNavigator")!
  const _component_ZoneAutocomplete = _resolveComponent("ZoneAutocomplete")!
  const _component_TableSkeleton = _resolveComponent("TableSkeleton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      showDelete: false,
      showSave: false,
      title: _ctx.$t('takers_availability.list.title')
    }, null, 8, ["title"]),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", null, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('period')), 1)
          ]),
          _createVNode(_component_WeekNavigator, {
            modelValue: _ctx.range,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => (_ctx.range = $event)),
              _ctx.onUpdateRange
            ]
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_ZoneAutocomplete, {
            id: "zone_autocomplete",
            modelValue: _ctx.selectedZone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedZone = $event)),
            style: {width: '250px'},
            onResultSelected: _ctx.search
          }, null, 8, ["modelValue", "onResultSelected"])
        ])
      ])
    ]),
    (_ctx.requestPending && !_ctx.dataset?.length)
      ? (_openBlock(), _createBlock(_component_TableSkeleton, {
          key: 0,
          columns: 7,
          hideHeader: true
        }))
      : (_ctx.dataset?.length)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_DataTable, {
              loading: _ctx.requestPending,
              paginator: false,
              scrollable: true,
              value: _ctx.dataset,
              class: "availability_datatable",
              responsiveLayout: "scroll",
              rowHover: "",
              scrollDirection: "vertical",
              scrollHeight: "500px",
              showGridlines: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  frozen: "",
                  header: "Taker",
                  style: {"min-width":"150px","width":"150px","background":"#f3c54c","color":"white"}
                }, {
                  body: _withCtx(({data: ta}) => [
                    _createVNode(_component_router_link, {
                      to: {
              name: 'takers-detail',
              params: {takerId: ta.id}
            },
                      class: "text-white"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(ta.name) + " " + _toDisplayString(ta.surname), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (wd, wd_i) => {
                  return (_openBlock(), _createBlock(_component_Column, {
                    key: `${wd_i}_${wd}`,
                    style: {"min-width":"250px","width":"250px"}
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("header", null, [
                        _withDirectives(_createElementVNode("div", _hoisted_7, [
                          _createTextVNode(_toDisplayString(wd), 1)
                        ], 512), [
                          [
                            _directive_tooltip,
                            _ctx.dateOf(wd_i),
                            void 0,
                            { bottom: true }
                          ]
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shifts, (s, s_i) => {
                            return _withDirectives((_openBlock(), _createElementBlock("span", {
                              key: `${s_i}_${s.id}`
                            }, [
                              _createTextVNode(_toDisplayString(s.name), 1)
                            ], 512)), [
                              [
                                _directive_tooltip,
                                _ctx.shiftDescritpion(s_i),
                                void 0,
                                { bottom: true }
                              ]
                            ])
                          }), 128))
                        ])
                      ])
                    ]),
                    body: _withCtx(({data: ta}) => [
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shifts, (s) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: `checkbox_s_${s.id}`
                          }, [
                            (_ctx.avExists(wd_i, ta, s.id))
                              ? _withDirectives((_openBlock(), _createBlock(_component_Checkbox, {
                                  key: 0,
                                  modelValue: _ctx.isConfirmed(wd_i, ta, s.id),
                                  binary: "",
                                  onClick: ($event: any) => (_ctx.onTaClick(wd_i, ta, s.id))
                                }, null, 8, ["modelValue", "onClick"])), [
                                  [_directive_tooltip, _ctx.dateOf(wd_i, s)]
                                ])
                              : (_openBlock(), _createElementBlock("i", _hoisted_10))
                          ], 64))
                        }), 128))
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["loading", "value"]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", null, [
                _hoisted_12,
                _createTextVNode(" - " + _toDisplayString(_ctx.$t('availability.taker_not_available')), 1)
              ]),
              _createElementVNode("span", _hoisted_13, [
                _createVNode(_component_Checkbox, {
                  modelValue: true,
                  binary: "",
                  readonly: ""
                }),
                _createTextVNode(" - " + _toDisplayString(_ctx.$t('availability.taker_confirmed')), 1)
              ]),
              _createElementVNode("span", _hoisted_14, [
                _createVNode(_component_Checkbox, {
                  modelValue: false,
                  binary: "",
                  readonly: ""
                }),
                _createTextVNode(" - " + _toDisplayString(_ctx.$t('availability.taker_not_confirmed')), 1)
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("h5", _hoisted_15, [
              _createElementVNode("i", null, _toDisplayString(_ctx.$t('availabilities.instructions')), 1)
            ]),
            (_ctx.requestCount)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_16, [
                  _createElementVNode("i", null, _toDisplayString(_ctx.$t('availabilities.no_records_found')), 1)
                ]))
              : _createCommentVNode("", true)
          ], 64))
  ]))
}